import { render, staticRenderFns } from "./ImageBanner.vue?vue&type=template&id=fee55b98&scoped=true&"
import script from "./ImageBanner.vue?vue&type=script&lang=js&"
export * from "./ImageBanner.vue?vue&type=script&lang=js&"
import style0 from "./ImageBanner.vue?vue&type=style&index=0&id=fee55b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee55b98",
  null
  
)

export default component.exports